<ion-header>
  <ion-toolbar>
    <ion-title>Zprávy</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false">
  @if (activeTab === MessagingTabName.ANNOUNCEMENTS) {
    <app-announcement-list [announcements]="announcements$ | async"></app-announcement-list>
  }

  @if (activeTab === MessagingTabName.PRIVATE_MESSAGES) {
    <app-private-message-list-wrapper
      [inboundMessages$]="inboundPrivateMessages$"
      [outboundMessages$]="outboundPrivateMessages$"
      (replyToMessage)="replyToPrivateMessage($event)"
      (loadInboundPrivateMessagesFromOffset)="service.inboundPrivateMessagesLoadOffset($event)"
      (loadOutboundPrivateMessagesFromOffset)="service.outboundPrivateMessagesLoadOffset($event)"
      (filterByAssistantId)="service.setAssistantFilter($event)"
      (filterByClientId)="service.setClientFilter($event)"
      (filterBySenderId)="service.setSenderFilter($event)"
      (fetchOnlyUnread)="service.setOnlyUnreadFilter($event)"
    ></app-private-message-list-wrapper>
  }

  @if (activeTab === MessagingTabName.SMS) {
    <app-sms-messages-list
      [inboundMessages$]="inboundSmsMessages$"
      [outboundMessages$]="outboundSmsMessages$"
      [workgroups]="workgroups$ | async"
      (loadInboundSmsFromOffset)="smsLoadInboundOffset($event)"
      (loadOutboundSmsFromOffset)="smsLoadOutboundOffset($event)"
      (workgroupFilterChanged)="smsWorkgroupFilterChanged($event)"
      (messageRead)="smsMessageRead($event)"
      (markAllMessagesRead)="smsMessagesReadAll()"
    ></app-sms-messages-list>
  }

  @if (activeTab === MessagingTabName.CLIENT_HISTORY) {
    <app-client-messages-history-list
      [messages]="clientOutboundMessages$ | async"
      [workgroups]="workgroups$ | async"
      (loadClientOutboundMessagesFromOffset)="clientOutboundMessagesLoadOffset($event)"
    ></app-client-messages-history-list>
  }

  <app-message-editor
    #editor
    id="editor"
    slot="fixed"
    [show]="editorShown"
    [parentMode]="activeMsgMode"
    [users]="users$ | async"
    [currentUser]="currentUser$ | async"
    (closeClick)="hideEditor()"
    (sendMessage)="sendMessage($event)"
  ></app-message-editor>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button (click)="fabClicked()">
      <ion-icon [name]="fabState.icon"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons class="ion-buttons-center">
      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.ANNOUNCEMENTS)"
        [selected]="activeTab === MessagingTabName.ANNOUNCEMENTS"
        [style.display]="!announcementsAllowed ? 'none' : null"
      >
        <ion-icon name="megaphone-outline"></ion-icon>
        <span>Nástěnka</span>
        @if (announcementsUnreadCount$ | async; as announcementsUnreadCount) {
          <ion-badge color="tertiary">{{ announcementsUnreadCount }}</ion-badge>
        }
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.PRIVATE_MESSAGES)"
        [selected]="activeTab === MessagingTabName.PRIVATE_MESSAGES"
      >
        <ion-icon name="mail-outline"></ion-icon>
        <span>Zprávy</span>
        @if (privateMessagesUnreadCount$ | async; as privateMessagesUnreadCount) {
          <ion-badge color="tertiary">{{ privateMessagesUnreadCount }}</ion-badge>
        }
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.SMS)"
        [selected]="activeTab === MessagingTabName.SMS"
        [style.display]="!smsAllowed ? 'none' : null"
      >
        <ion-icon name="phone-portrait-outline"></ion-icon>
        <span>Sms</span>
        @if (smsMessagesUnreadCount$ | async; as smsUnreadCount) {
          <ion-badge color="tertiary">{{ smsUnreadCount }}</ion-badge>
        }
      </ion-tab-button>

      <ion-tab-button
        (click)="switchTabTo(MessagingTabName.CLIENT_HISTORY)"
        [selected]="activeTab === MessagingTabName.CLIENT_HISTORY"
        [style.display]="!clientHistoryAllowed ? 'none' : null"
      >
        <ion-icon name="time-outline"></ion-icon>
        <span>Klienti - odeslané maily</span>
      </ion-tab-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
